import{createContext}from"react";export default createContext({updateTabList:()=>{},resetTabList:()=>{},active:null});